import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import Dashboard from "./pages/Dashboard";
import CharacterBuilder from "./pages/CharacterBuilder";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <div className="noise-overlay" />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/builder" element={<CharacterBuilder />} />
          <Route path="/builder/:characterId" element={<CharacterBuilder />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors />
    </div>
  );
}

export default App;
